export default __webpack_public_path__ + "static/media/1.3bab6135.png";